/*!
 Leaflet custom pure-HTML rectangle tied to the map
 (c) 2018 Andxor soluzioni informatiche <http://www.andxor.it/>
*/

import { Layer } from 'leaflet/src/layer/Layer';
import { LatLngBounds } from 'leaflet/src/geo/LatLngBounds';
import * as DomUtil from 'leaflet/src/dom/DomUtil';
import log from 'log';

export var Div = Layer.extend({

    initialize: function (latLngBounds, options) {
        this._pos = latLngBounds;
        if (!(this._pos instanceof LatLngBounds))
            this._pos = new LatLngBounds(this._pos);
        //log('Options: ', options);
        if (!(this._pos instanceof LatLngBounds))
            this._pos = new LatLngBounds(this._pos);
        //log('Options:', options);
        this._options = options;
    },

    onAdd: function (map) {
        //log('onAdd');
        this._map = map;
        var div = this._div = DomUtil.create('div', 'my-div');
        div.style.position = 'absolute';
        if (this._options.color)
            div.style.backgroundColor = this._options.color;
        this._setPosition();
        this.getPane().appendChild(div);
    },

    onRemove: function () {
        this._div.remove();
    },

    getEvents: function () {
        var events = {
            // viewreset: this._reset,
            // zoom: this._onZoom,
            // moveend: this._update,
            zoomend: this._onZoom
        };
        // if (this._zoomAnimated)
        //     events.zoomanim = this._onZoom;
        return events;
    },

    _setPosition: function () {
        var div = this._div,
            c1 = this._map.latLngToLayerPoint(this._pos.getNorthWest()),
            c2 = this._map.latLngToLayerPoint(this._pos.getSouthEast());
        //log('Pos: ' + c1 + '-' + c2);
        div.style.left = Math.min(c1.x, c2.x) + 'px';
        div.style.top = Math.min(c1.y, c2.y) + 'px';
        div.style.width = Math.abs(c1.x - c2.x) + 'px';
        div.style.height = Math.abs(c1.y - c2.y) + 'px';
    },

    _onZoom: function (ev) {
        //log('onZoom', ev.target);
        log('Evento zoom: ', ev.sourceTarget._zoom);
        this._setPosition();
    },

    getDOM: function () {
        return this._div;
    }

});

// var div = new L.Layer.Div([[ 10, 10 ], [ 20, 100 ]]).addTo(pdfmap).getDOM();
// var div = new Layer.Div([[ 10, 10 ], [ 20, 100 ]]).addTo(pdfmap).getDOM();
// div.style.background = 'red';
// div.innerHTML = 'xxx';
